import * as CookieConsent from 'vanilla-cookieconsent';

window.dataLayer = window.dataLayer || [];
function gtag(...args) {
    window.dataLayer.push(args);
}

gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'denied',
});

if (CookieConsent.getCookie('categories', 'cc_cookie')) {
    const acceptedCategories = CookieConsent.getCookie('categories', 'cc_cookie') || [];
    gtag('consent', 'update', {
        functionality_storage: acceptedCategories.includes('functionality') ? 'granted' : 'denied',
        ad_storage: acceptedCategories.includes('marketing') ? 'granted' : 'denied',
        ad_user_data: acceptedCategories.includes('marketing') ? 'granted' : 'denied',
        ad_personalization: acceptedCategories.includes('marketing') ? 'granted' : 'denied',
        analytics_storage: acceptedCategories.includes('analytics') ? 'granted' : 'denied',
        personalization_storage: acceptedCategories.includes('personalization') ? 'granted' : 'denied',
        security_storage: acceptedCategories.includes('security') ? 'granted' : 'denied',
    });
}

function manageConsent() {
    gtag('consent', 'update', {
        functionality_storage: CookieConsent.acceptedCategory('functionality') ? 'granted' : 'denied',
        ad_storage: CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        ad_user_data: CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        ad_personalization: CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        analytics_storage: CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        personalization_storage: CookieConsent.acceptedCategory('personalization') ? 'granted' : 'denied',
        security_storage: CookieConsent.acceptedCategory('security') ? 'granted' : 'denied',
    });
}

window.addEventListener('load', () => {
    /**
     * All config. options available here:
     * https://cookieconsent.orestbida.com/reference/configuration-reference.html
     */
    CookieConsent.run({
        categories: {
            necessary: {
                enabled: true, // this category is enabled by default
                readOnly: true, // this category cannot be disabled
            },
            analytics: {},
        },

        language: {
            default: 'fr-CA',
            autoDetect: 'document',
            translations: {
                'en-CA': {
                    consentModal: {
                        description:
                            "We place great importance on the protection of your privacy. Our data collection practices are governed by a transparent Privacy Policy. By browsing this site, you consent to the use of cookies and other technologies to enhance your experience and analyze site usage. You have the option to manage your preferences by customizing site or browser settings. You can also adjust your choice at any time by clicking the 'Manage Cookie Preferences' link located in the footer. Please refer to our <a href='/en/privacy-policy/' class='cc-link'>Privacy Policy</a> for more information.",
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        showPreferencesBtn: 'Manage preferences',
                    },
                    preferencesModal: {
                        title: 'Cookie preferences',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        savePreferencesBtn: 'Save preferences',
                        closeIconLabel: 'Close modal',
                        serviceCounterLabel: 'Service|Services',
                        sections: [
                            {
                                title: null,
                                description:
                                    'We use cookies to help you navigate efficiently and perform certain functions. Detailed information about all cookies can be found under each consent category below. <br><br>You can choose to enable or disable these cookies in whole or in part. However, please note that disabling some of them may impact your browsing experience.',
                            },
                            {
                                title: "Necessary cookies <span class='pm__badge'>Always Enabled</span>",
                                description:
                                    "Cookies categorized as 'necessary' are stored on your browser and are essential for the basic functionalities of the site. Crucial for the proper functioning of the site, necessary cookies do not store any personally identifiable information.",
                                linkedCategory: 'necessary',
                                cookieTable: {
                                    headers: {
                                        name: 'Name',
                                        description: 'Description',
                                        domain: 'Domain',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: '_GRECAPTCHA',
                                            description:
                                                'This cookie is set by Google reCAPTCHA, which protects the site against spam enquiries on contact forms.',
                                            domain: 'google.com',
                                            expiration: '6 months',
                                        },
                                        {
                                            name: 'wp-wpml_current_language',
                                            description: "This cookie allows saving the user's language preference.",
                                            domain: window.location.hostname,
                                            expiration: '1 day',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Optional cookies',
                                description:
                                    'We use third-party cookies to analyze your usage of the site. Analytics cookies provide information about visitor interactions, including the number, bounce rate, traffic source, etc. These cookies will only be stored in your browser with your prior consent.',
                                linkedCategory: 'analytics',
                                cookieTable: {
                                    headers: {
                                        name: 'Nom',
                                        description: 'Description',
                                        domain: 'Domaine',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: '__Secure-1PAPISID',
                                            description:
                                                "This cookie is used for targeting purposes to build a profile of the website visitor's interests in order to show relevant & personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '__Secure-1PSID',
                                            description:
                                                "This cookie is used for targeting purposes to build a profile of the website visitor's interests in order to show relevant and personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '__Secure-1PSIDCC',
                                            description:
                                                "This cookie is used for targeting purposes to build a profile of the website visitor's interests in order to show relevant & personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '1 year',
                                        },
                                        {
                                            name: '__Secure-1PSIDTS',
                                            description:
                                                "This cookie is used for targeting purposes to build a profile of the website visitor's interests in order to show relevant & personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '1 year',
                                        },
                                        {
                                            name: '__Secure-3PAPISID',
                                            description:
                                                "This cookie is used for targeting purposes to build a profile of the website visitor's interests in order to show relevant and personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '__Secure-3PSID',
                                            description:
                                                "This cookie is used for targeting purposes to build a profile of the website visitor's interests in order to show relevant and personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '__Secure-3PSIDCC',
                                            description:
                                                'This cookie is used by Google to build a profile of website visitor interests to show relevant and personalised ads through retargeting.',
                                            domain: 'google.com',
                                            expiration: '1 year',
                                        },
                                        {
                                            name: '_ga',
                                            description:
                                                "This cookie is installed by Google Analytics. The cookie is used to calculate visitor, session, campaign data and keep track of site usage for the site's analytics report. The cookies store information anonymously and assigns a randomly generated number to identify unique visitors.",
                                            domain: 'google.com',
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '_gid',
                                            description:
                                                'This cookie is installed by Google Analytics. The cookie is used to store information of how visitors use a website and helps in creating an analytics report of how the website is doing. The data collected includes the number of visitors, the source where they have come from, and the pages visited in an anonymous form.',
                                            domain: 'google.com',
                                            expiration: '1 day',
                                        },
                                        {
                                            name: '1P_JAR',
                                            description:
                                                'This cookie collects statistics on website usage and measures conversions. A conversion occurs, for example, when a user becomes a buyer. The cookie is also used to display relevant ads to users. Furthermore, the cookie can be used to prevent a user from seeing the same ad more than once.',
                                            domain: 'google.com',
                                            expiration: '1 month',
                                        },
                                        {
                                            name: 'AEC',
                                            description:
                                                'This cookie is used by Google to ensure that requests within a browsing session are made by the user, and not by other sites.',
                                            domain: 'google.com',
                                            expiration: '6 months',
                                        },
                                        {
                                            name: 'APISID',
                                            description:
                                                'This cookie is used by Google to display personalised advertisements on Google sites, based on recent searches and previous interactions.',
                                            domain: 'google.com',
                                            expiration: '1 year',
                                        },
                                        {
                                            name: 'HSID',
                                            description:
                                                'This cookie contains digitally signed and encrypted records of a user’s Google Account ID and most recent sign-in time.',
                                            domain: 'google.com',
                                            expiration: '2 years',
                                        },
                                        {
                                            name: 'NID',
                                            description:
                                                'This cookie is used to show Google ads in Google services for signed-out users.',
                                            domain: 'google.com',
                                            expiration: '5 years',
                                        },
                                        {
                                            name: 'OTZ',
                                            description:
                                                'The OTZ cookie is set by Google Analytics and is used to provide an aggregate analysis of website visitors.',
                                            domain: 'google.com',
                                            expiration: '1 month',
                                        },
                                        {
                                            name: 'SEARCH_SAMESITE',
                                            description:
                                                'This cookie is used for the correct sending of data to Google.',
                                            domain: 'google.com',
                                            expiration: '5 months',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'More information',
                                description:
                                    "For any query in relation to my policy on cookies and your choices, please <a class='cc__link' href='/en/privacy-policy/'>contact me</a>.",
                            },
                        ],
                    },
                },
                'fr-CA': {
                    consentModal: {
                        description:
                            "Nous attachons une grande importance à la protection de votre vie privée. Nos pratiques de collecte de données sont régies par une Politique de confidentialité transparente. En naviguant sur ce site, vous consentez à l'utilisation de témoins (cookies) et d'autres technologies pour améliorer votre expérience et analyser l'utilisation du site. Vous avez la possibilité de gérer vos préférences en personnalisant les paramètres du site ou de votre navigateur. Vous pouvez également ajuster votre choix à tout moment en cliquant sur le lien 'Gestion des témoins de navigation', situé dans le pied de page. Consultez notre <a href='/politique-de-confidentialite/' class='cc-link'>Politique de confidentialité</a> pour plus d'informations.",
                        acceptAllBtn: 'Tout accepter',
                        acceptNecessaryBtn: 'Tout rejeter',
                        showPreferencesBtn: 'Gérer les préférences',
                    },
                    preferencesModal: {
                        title: 'Personnaliser vos préférences en matière de consentement',
                        acceptAllBtn: 'Tout accepter',
                        acceptNecessaryBtn: 'Tout rejeter',
                        savePreferencesBtn: 'Sauvegarder les préférences',
                        closeIconLabel: 'Fermer la modale',
                        serviceCounterLabel: 'Services',
                        sections: [
                            {
                                title: null,
                                description:
                                    "Nous utilisons des témoins (cookies) pour vous aider à naviguer efficacement et à exécuter certaines fonctionnalités. Vous trouverez des informations détaillées sur tous les cookies sous chaque catégorie de consentement ci-dessous. <br><br>Vous pouvez choisir d'activer tout ou de désactiver en partie ces témoins. Toutefois, veuillez noter que la désactivation de certains d'entre eux pourrait avoir un impact sur votre expérience de navigation. ",
                            },
                            {
                                title: 'Témoins (cookies) obligatoires',
                                description:
                                    "Les témoins catégorisés comme 'nécessaires' sont stockés sur votre navigateur et sont essentiels pour les fonctionnalités de base du site. Cruciaux pour le bon fonctionnement du site, les témoins nécessaires ne stockent aucune donnée personnellement identifiable.",
                                linkedCategory: 'necessary',
                            },
                            {
                                title: 'Témoins (cookies) facultatifs',
                                description:
                                    "Nous utilisons des témoins tiers pour analyser votre utilisation du site. Les témoins d’analytique fournissent des informations sur les interactions des visiteurs, notamment le nombre, le taux de rebond, la source de trafic, etc. Ces témoins ne seront stockés dans votre navigateur qu'avec votre consentement préalable.",
                                linkedCategory: 'analytics',
                                cookieTable: {
                                    headers: {
                                        name: 'Nom',
                                        description: 'Description',
                                        domain: 'Domaine',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: '_ga',
                                            description: "Cookie set by <a href='#das'>Google Analytics</a>.",
                                            domain: 'Google Analytics',
                                            expiration: 'Expires after 12 days',
                                        },
                                        {
                                            name: '_gid',
                                            description: "Cookie set by <a href='#das'>Google Analytics</a>",
                                            domain: 'Google Analytics',
                                            expiration: 'Session',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Pour en savoir plus',
                                description:
                                    "Pour plus d’information, consultez notre <a class='cc-link' href='#yourdomain.com'>Politique de confidentialité</a>.",
                            },
                        ],
                    },
                },
            },
        },

        onFirstConsent: (...args) => {
            manageConsent(args);
            window.dataLayer.push({ event: 'consent_ready' });
        },
        onChange: (...args) => {
            manageConsent(args);
            window.dataLayer.push({ event: 'consent_update' });
        },
    });
});
